/**
 * Hiển thị `submission_values` — các chỉ số máy chủ trích ra lúc nộp phiếu.
 *
 * Chúng được tính và lưu từ đầu nhưng chưa màn hình nào đọc; đây là lớp dùng chung
 * cho hai chỗ cần: thẻ chỉ số của phiếu đã khoá, và dòng thời gian phiếu của Hộ
 * (US C2 — "theo dõi biến động năng suất, mật độ cây qua các đợt điều tra").
 *
 * Nhãn đặt ở đây chứ không ở máy chủ: `metric_key` là khoá kỹ thuật dùng chung cho
 * cả file xuất lẫn hệ thống tính carbon, đổi nó để cho đẹp trên giao diện là phá
 * hợp đồng dữ liệu với bên tiêu thụ.
 */

const METRIC_LABEL = {
  area_ha: 'Diện tích',
  coffee_density_per_ha: 'Mật độ cà phê',
  yield_per_ha: 'Năng suất',
  fert_inorg_per_ha: 'Phân vô cơ',
};

/** Thứ tự hiển thị — diện tích trước vì các chỉ số còn lại đều chia cho nó. */
const METRIC_ORDER = ['area_ha', 'coffee_density_per_ha', 'yield_per_ha', 'fert_inorg_per_ha'];

export function metricLabel(key) {
  return METRIC_LABEL[key] || key;
}

/**
 * Làm tròn theo độ lớn: 4166.666666666667 kg/ha đọc là "4.167", còn 1.2 ha mà làm
 * tròn thành "1" thì mất đúng phần người dùng cần thấy.
 */
export function formatMetric(value) {
  // `metric_value` là cột nullable. Không chặn null/'' ở đây thì `Number(null)`
  // ra 0 và giao diện hiện "0 kg/ha" cho một chỉ số chưa tính được — trong khi 0
  // là một giá trị hợp lệ, nên người đọc không có cách nào phân biệt hai trường hợp.
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const soLe = Math.abs(n) >= 100 ? 0 : Math.abs(n) >= 10 ? 1 : 2;
  return n.toLocaleString('vi-VN', { minimumFractionDigits: 0, maximumFractionDigits: soLe });
}

/** Sắp theo thứ tự đã định, chỉ số lạ (thêm sau này) xếp cuối theo tên. */
export function sortMetrics(values = []) {
  return [...values].sort((a, b) => {
    const ia = METRIC_ORDER.indexOf(a.metricKey);
    const ib = METRIC_ORDER.indexOf(b.metricKey);
    if (ia === -1 && ib === -1) return a.metricKey.localeCompare(b.metricKey);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });
}

/** "1.150 gốc/ha" — một chỉ số gọn trên một dòng. */
export function formatMetricValue(v) {
  return `${formatMetric(v.metricValue)}${v.unit ? ` ${v.unit}` : ''}`;
}
